import { useAuthenticator } from '@aws-amplify/ui-react';
import { Card, Container, Typography } from '@mui/material';

const Home = () => {
  const { user } = useAuthenticator((context) => [context.user]);
  return (
    <Container>
      <Card sx={{ padding: { xs: '2rem 1rem', md: '5rem' } }}>
        <Typography variant="h1" sx={{ overflowWrap: 'anywhere' }}>
          Welcome, {user?.username}!
        </Typography>
      </Card>
    </Container>
  );
};

export default Home;
